/* eslint @typescript-eslint/naming-convention: 0 */

import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface DrawerImpressionParams {
  experience_id: string;
}

/**
 * 発火タイミング: 体験詳細ページで施設情報ドロワーの起動リンクが描画された時（1ページあたり1回）。
 *
 * 一次指標「ドロワー起動 → 問い合わせ率」の**分母**。起動リンクが入稿されていないプランは
 * ドロワーに到達できないため、描画されたことを条件にして分母を到達可能なセッションに限る（D-008）。
 */
export const sendGAWabunkaDrawerImpressionEvent = (params: { experienceId: string }) => {
  sendWabunkaGAEvent('drawer_impression', {
    experience_id: params.experienceId,
  });
};
